// The session store is used to store any session level settings that don't
// need to be preserved across sessions in the KV store.  Lighter weight
// options like selected tabs can go here.

const state = {};

const actions = {
  ClearSessionSettings({ commit }) {
    commit('CLEAR_SESSION_SETTINGS');
  },

  SetSessionSetting({ commit }, { key, value }) {
    commit('SET_SESSION_SETTING', { key, value });
  },
};

const mutations = {
  SET_SESSION_SETTING(stateArg, { key, value }) {
    const stateCopy = stateArg;
    stateCopy[key] = value;
  },

  CLEAR_SESSION_SETTINGS(stateArg) {
    let stateCopy = stateArg;
    stateCopy = {};
  },
};

export default { actions, mutations, state };
